import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'lina-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent implements OnInit {
  @Input() overrideIcon: string;
  @Input() theme: string;
  @Input() messageTitle: string;
  @Input() content: string;
  @Input() large: string;
  icon: string;

  constructor() {
  }

  ngOnInit() {
/*    Available themes
    - info
    - error
    - warning
    - done
    - incident
    - incidentLight
*/

    this.icon = this.theme || 'info';
    this.theme = this.theme || 'default';

    if (this.large) {
      this.theme += ' large';
    }

    this.icon = this.overrideIcon || this.icon;
  }

}
